<template>
 <div class="md:hidden ">
 
  <MobileSearchBar />
</div>
  <div class="max-w-3xl mx-auto px-4 md:py-12 sm:py-6">
    <!-- When loading -->
    <LoadingSpinner
      v-if="loading"
      message="Processing data..."
      size="lg"
      color="green"
    />

    <div v-else-if="product" class="space-y-10">
      <!-- Product Image Section -->
      <div class="space-y-4 text-center">
        <div
          class="relative overflow-hidden rounded-xl shadow"
          @mousedown="startDrag"
          @mousemove="handleDrag"
          @mouseup="endDrag"
          @mouseleave="endDrag"
          @touchstart="startDrag"
          @touchmove="handleDrag"
          @touchend="endDrag"
        >
          <img
            :src="activeImage"
            class="w-full h-[300px] object-contain mx-auto"
          />
        </div>

        <div
          class="flex gap-2 overflow-x-auto mt-2 no-scrollbar cursor-grab select-none thumbnail-scroll-container"
          ref="thumbnailContainer"
          @mousedown.prevent="onScrollStart"
          @mousemove.prevent="onScrollMove"
          @mouseup.prevent="onScrollEnd"
          @mouseleave.prevent="onScrollEnd"
          @touchstart.passive="onScrollStart"
          @touchmove.passive="onScrollMove"
          @touchend.prevent="onScrollEnd"
        >
          <img
            v-for="(img, index) in productGallery"
            :key="index"
            :src="img"
            @click.stop="activeImage = img"
            class="h-20 object-cover rounded cursor-pointer border flex-shrink-0"
            :class="{ 'border-teal-500 border-2': activeImage === img }"
            draggable="false"
          />
        </div>
      </div>

      <!-- Product Info Section -->
      <div class="text-center">
        <h2 class="text-3xl font-bold text-gray-800 mb-2">
          {{ product.name }}
        </h2>
        <p class="text-sm text-gray-500">
          {{ $t("productDetails.category") }}: {{ product.category_name }} /
          {{ product.sub_category_name }}
        </p>
        <p class="text-gray-500">
          {{ $t("productDetails.serviceNo") }}:   {{ product.id }}
        </p>

        <div class="my-4">
  <span class="text-2xl font-bold text-teal-600 inline-flex items-center gap-1">
    <img src="/R.svg" alt="SAR" class="w-5 h-5" />
    {{ discountedPrice }}
  </span>

  <span
    v-if="product.discount"
    class="ml-2 text-gray-400 line-through inline-flex items-center gap-1"
  >
    <img src="/R.svg" alt="SAR" class="w-4 h-4" />
    {{ product.price.toFixed(2) }}
  </span>

  <span
    v-if="product.discount"
    class="ml-2 bg-red-100 text-red-800 text-xs font-semibold px-2 py-0.5 rounded"
  >
    {{ product.discount }}% OFF
  </span>
</div>


        <p class="text-gray-600 mb-6">
          {{ product.shortDescription }}
        </p>

        <div class="flex justify-center gap-4 flex-wrap">
          <button
            @click="chatWithSeller(product)"
            class="bg-purple-600 text-white font-semibold px-6 py-3 rounded hover:bg-purple-700 transition"
          >
            💬 {{ $t("productDetails.chatWithSeller") }}
          </button>

          <button
            @click="toggleWishlist(product.id)"
            class="p-3 border rounded hover:bg-gray-50 transition"
            :class="{
              'text-teal-600 border-teal-200 bg-teal-50': isInWishlist(product.id)
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              :fill="isInWishlist(product.id) ? 'currentColor' : 'none'"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
              />
            </svg>
          </button>
        </div>
      </div>

      <!-- Product Description Section -->
 <div>
  <h3 class="text-lg font-medium text-gray-900 mb-4">
    {{ $t("productDetails.productDescription") }}
  </h3>
  <div class="prose max-w-none text-gray-600 mb-6">
    <p class="whitespace-pre-line">
        {{ formattedDescription }}
    </p>

    <h4 class="text-md font-medium mt-6 mb-2">
      {{ $t("productDetails.itemDetails") }}
    </h4>
    <div class="grid lg:grid-cols-2 sm:grid-cols-1 gap-1">
      <div v-for="field in product.fields" :key="field.id">
        <span style="font-family: Arial;">&bull;</span> {{ field.label }}: {{ formatFieldValue(field.value) }}
      </div>
    </div>
    <!-- <ul class="list-disc pl-5 space-y-1">
      <li v-for="field in product.fields" :key="field.id">
        {{ field.label }}: {{ formatFieldValue(field.value) }}
      </li>
    </ul> -->
  </div>
</div>
    </div>
  </div>
</template>
<script>

import { inject, ref } from "vue";
import api from "@/api";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import eventBus from "@/eventBus";
import MobileSearchBar from "@/components/MobileSearchBar.vue";
export default {
  name: "ProductDetails",
  components: { LoadingSpinner , MobileSearchBar },
  setup() {
    const cartStore = inject("cartStore");
    const isMobile = ref(window.innerWidth < 768);
    return { cartStore, isMobile };
  },
  data() {
    return {
      loading: true,
      product: null,
      activeImage: null,
      dragStartX: null,
      productGallery: [],
      dragThumbStartX: null,
      scrollStartX: 0,
      isScrolling: false,
    };
  },
  computed: {
      formattedDescription() {
    if (!this.product.description) return '';
    return this.product.description
      .split('*')
      .filter(Boolean)
      .map(part => `*${part.trim()}`)
      .join('\n');
  },

    discountedPrice() {
      if (!this.product) return 0;
      const { price, discount } = this.product;
      return (price * (1 - (discount || 0) / 100)).toFixed(2);
    },
  },
  methods: {
      onScrollStart(e) {
      this.isScrolling = true;
      const pageX = e.type.includes("mouse") ? e.pageX : e.touches[0].pageX;
      this.scrollStartX = pageX;
      this.dragStartX = this.$refs.thumbnailContainer.scrollLeft;
    },
    onScrollMove(e) {
      if (!this.isScrolling) return;
      const pageX = e.type.includes("mouse") ? e.pageX : e.touches[0].pageX;
      const walk = (this.scrollStartX - pageX) * 1.5;
      this.$refs.thumbnailContainer.scrollLeft = this.dragStartX + walk;
    },
    onScrollEnd() {
      this.isScrolling = false;
    },
    formatFieldValue(value) {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed.join(", ");
      } catch {
        return value;
      }
      return value;
    },
    chatWithSeller(product) {
      if (!product.user_id) return;
      const message = `🛒 *${product.name}* is available for $${product.price}.\nCheck it here: ${window.location.origin}/product/${product.id}`;
      eventBus.emit("open-chat", { userId: product.user_id, product, autoMessage: message });
    },
    getFullImageUrl(img) {
      return `https://admin.from-malk.com/storage/${img}`;
    },
    toggleWishlist(id) {
      this.cartStore.toggleWishlist(id);
    },
    isInWishlist(id) {
      return this.cartStore.isInWishlist(id);
    },
    startDrag(e) {
      this.dragStartX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
    },
    handleDrag(e) {
      if (this.dragStartX === null) return;
      const currentX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
      const deltaX = currentX - this.dragStartX;
      if (Math.abs(deltaX) > 50) {
        const currentIndex = this.productGallery.indexOf(this.activeImage);
        const nextIndex = deltaX > 0 ? currentIndex - 1 : currentIndex + 1;
        if (this.productGallery[nextIndex]) this.activeImage = this.productGallery[nextIndex];
        this.dragStartX = null;
      }
    },
    endDrag() {
      this.dragStartX = null;
    },
    startThumbDrag(e) {
      this.dragThumbStartX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
    },
    handleThumbDrag(e) {
      if (this.dragThumbStartX === null) return;
      const currentX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
      const deltaX = currentX - this.dragThumbStartX;
      this.$refs.thumbnailContainer.scrollLeft -= deltaX;
      this.dragThumbStartX = currentX;
    },
    endThumbDrag() {
      this.dragThumbStartX = null;
    },
  },
  created() {
    const id = this.$route.params.id;
    api.get(`/v1/items/${id}`).then((res) => {
      this.product = res.data;
      if (Array.isArray(this.product.image)) {
        this.productGallery = this.product.image.map((img) => this.getFullImageUrl(img));
        this.activeImage = this.productGallery[0];
      } else {
        const img = this.getFullImageUrl(this.product.image);
        this.productGallery = [img];
        this.activeImage = img;
      }
    }).catch(console.error).finally(() => {
      this.loading = false;
    });
  },
};
</script>
<style scoped>
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.thumbnail-scroll-container {
  scroll-behavior: smooth;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>
